import { PageLayout } from "@/components/PageLayout";
import { Hero } from "@/components/Hero";
import { TrustBadges } from "@/components/TrustBadges";
import { Services } from "@/components/Services";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { useSEO } from "@/hooks/useSEO";
import { lazy, Suspense } from "react";

// Lazy load heavy components that are below the fold
const PoolCalculator = lazy(() => import("@/components/PoolCalculator"));
const Testimonials = lazy(() => import("@/components/Testimonials").then(module => ({ default: module.Testimonials })));
const FAQ = lazy(() => import("@/components/FAQ").then(module => ({ default: module.FAQ })));
const Contact = lazy(() => import("@/components/Contact").then(module => ({ default: module.Contact })));

const Index = () => {
  useSEO({
    title: "BlueLux Pool Services | Premium Pool Maintenance in San Diego",
    description: "Professional pool cleaning and maintenance services in San Diego. From luxury estates to family pools, we provide reliable pool care you can trust. Schedule your service today!",
    keywords: "pool service San Diego, pool cleaning, pool maintenance, pool repair, luxury pool care, residential pool service",
    canonical: "https://bluelux.com/",
    structuredData: {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "BlueLux Pool Services",
      "description": "Premium pool maintenance and cleaning services in San Diego County",
      "url": "https://bluelux.com",
      "telephone": "+1-601-BLUE-LUX",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "San Diego",
        "addressRegion": "CA",
        "addressCountry": "US"
      },
      "areaServed": [
        "La Jolla", "Del Mar", "Encinitas", "Solana Beach", "Cardiff by the Sea",
        "Rancho Santa Fe", "Fairbanks Ranch", "Carmel Valley", "Torrey Highlands"
      ],
      "serviceType": ["Pool Cleaning", "Pool Maintenance", "Pool Repair", "Chemical Balancing"]
    }
  });

  return (
    <PageLayout isHomePage={true}>
      <Hero />
      <TrustBadges />
      <Services />
      <Suspense fallback={<div className="min-h-[400px] flex items-center justify-center"><div className="text-muted-foreground">Loading...</div></div>}>
        <PoolCalculator />
      </Suspense>
      <WhyChooseUs />
      <Suspense fallback={<div className="min-h-[300px] flex items-center justify-center"><div className="text-muted-foreground">Loading...</div></div>}>
        <Testimonials />
      </Suspense>
      <Suspense fallback={<div className="min-h-[500px] flex items-center justify-center"><div className="text-muted-foreground">Loading...</div></div>}>
        <Contact />
      </Suspense>
      <Suspense fallback={<div className="min-h-[400px] flex items-center justify-center"><div className="text-muted-foreground">Loading...</div></div>}>
        <FAQ />
      </Suspense>
    </PageLayout>
  );
};

export default Index;
